/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createWorkPackageDependency } from '../fn/work-package-dependencies/create-work-package-dependency';
import { CreateWorkPackageDependency$Params } from '../fn/work-package-dependencies/create-work-package-dependency';
import { deleteWorkPackageDependency } from '../fn/work-package-dependencies/delete-work-package-dependency';
import { DeleteWorkPackageDependency$Params } from '../fn/work-package-dependencies/delete-work-package-dependency';
import { listWorkPackageDependencies } from '../fn/work-package-dependencies/list-work-package-dependencies';
import { ListWorkPackageDependencies$Params } from '../fn/work-package-dependencies/list-work-package-dependencies';
import { WorkPackageDependencyDto } from '../models/work-package-dependency-dto';
import { WorkPackageDependencyDtoPage } from '../models/work-package-dependency-dto-page';

@Injectable({ providedIn: 'root' })
export class WorkPackageDependenciesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listWorkPackageDependencies()` */
  static readonly ListWorkPackageDependenciesPath = '/v0/workPackageDependencies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listWorkPackageDependencies()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackageDependencies$Response(params?: ListWorkPackageDependencies$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageDependencyDtoPage>> {
    return listWorkPackageDependencies(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listWorkPackageDependencies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listWorkPackageDependencies(params?: ListWorkPackageDependencies$Params, context?: HttpContext): Observable<WorkPackageDependencyDtoPage> {
    return this.listWorkPackageDependencies$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageDependencyDtoPage>): WorkPackageDependencyDtoPage => r.body)
    );
  }

  /** Path part for operation `createWorkPackageDependency()` */
  static readonly CreateWorkPackageDependencyPath = '/v0/workPackageDependencies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkPackageDependency()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackageDependency$Response(params: CreateWorkPackageDependency$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageDependencyDto>> {
    return createWorkPackageDependency(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createWorkPackageDependency$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkPackageDependency(params: CreateWorkPackageDependency$Params, context?: HttpContext): Observable<WorkPackageDependencyDto> {
    return this.createWorkPackageDependency$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPackageDependencyDto>): WorkPackageDependencyDto => r.body)
    );
  }

  /** Path part for operation `deleteWorkPackageDependency()` */
  static readonly DeleteWorkPackageDependencyPath = '/v0/workPackageDependencies/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteWorkPackageDependency()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkPackageDependency$Response(params: DeleteWorkPackageDependency$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteWorkPackageDependency(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteWorkPackageDependency$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteWorkPackageDependency(params: DeleteWorkPackageDependency$Params, context?: HttpContext): Observable<void> {
    return this.deleteWorkPackageDependency$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
